import React, { useEffect, useState } from 'react';
import { Container, Typography, Box, Button, Card, CardContent, CircularProgress } from '@mui/material';
import { CheckCircle as CheckIcon, Error as ErrorIcon } from '@mui/icons-material';
import { useNavigate, useSearchParams } from 'react-router-dom';

export default function Confirmacion() {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const [status, setStatus] = useState('loading');

  useEffect(() => {
    const mpStatus = searchParams.get('status') || searchParams.get('collection_status');
    const paymentId = searchParams.get('payment_id') || searchParams.get('collection_id');

    if (mpStatus === 'approved' || mpStatus === 'authorized') {
      setStatus('success');
    } else if (mpStatus === 'pending' || mpStatus === 'in_process') {
      setStatus('pending');
    } else {
      setStatus('error');
    }
  }, [searchParams]);

  if (status === 'loading') {
    return (
      <Box sx={{ display: 'flex', justifyContent: 'center', p: 8 }}>
        <CircularProgress />
      </Box>
    );
  }

  const configs = {
    success: {
      icon: <CheckIcon sx={{ fontSize: 80, color: '#10B981' }} />,
      title: 'Pago exitoso',
      message: 'Tu suscripción ha sido activada. Ya puedes disfrutar de todas las funcionalidades de tu plan.',
      color: '#10B981',
      bgColor: '#ECFDF5',
    },
    pending: {
      icon: <CheckIcon sx={{ fontSize: 80, color: '#F59E0B' }} />,
      title: 'Pago en proceso',
      message: 'Tu pago está siendo procesado. Te notificaremos cuando se confirme. Esto puede tomar unos minutos.',
      color: '#F59E0B',
      bgColor: '#FFF7ED',
    },
    error: {
      icon: <ErrorIcon sx={{ fontSize: 80, color: '#EF4444' }} />,
      title: 'Pago no completado',
      message: 'El pago no pudo ser procesado. Puedes intentar nuevamente o contactarnos por WhatsApp.',
      color: '#EF4444',
      bgColor: '#FEF2F2',
    },
  };

  const cfg = configs[status];

  return (
    <Container maxWidth="sm" sx={{ py: 8 }}>
      <Card sx={{ borderRadius: 4, border: `2px solid ${cfg.color}20`, overflow: 'hidden' }}>
        <Box sx={{ bgcolor: cfg.bgColor, p: 4, textAlign: 'center' }}>
          {cfg.icon}
          <Typography variant="h4" fontWeight={800} color={cfg.color} sx={{ mt: 2 }}>
            {cfg.title}
          </Typography>
        </Box>
        <CardContent sx={{ p: 4, textAlign: 'center' }}>
          <Typography variant="body1" color="text.secondary" sx={{ mb: 4 }}>
            {cfg.message}
          </Typography>

          <Box sx={{ display: 'flex', gap: 2, justifyContent: 'center', flexWrap: 'wrap' }}>
            <Button
              variant="contained"
              onClick={() => navigate('/home/suscripcion')}
              sx={{ bgcolor: '#1E2783', '&:hover': { bgcolor: '#141A5C' }, borderRadius: 2, fontWeight: 700 }}
            >
              Ver mi plan
            </Button>
            <Button
              variant="outlined"
              onClick={() => navigate('/home')}
              sx={{ borderColor: '#1E2783', color: '#1E2783', borderRadius: 2 }}
            >
              Ir al inicio
            </Button>
            {status === 'error' && (
              <Button
                variant="contained"
                href="https://wa.me/51993540571?text=Hola, tuve un problema con mi pago en TRACKEA"
                target="_blank"
                sx={{ bgcolor: '#25D366', '&:hover': { bgcolor: '#128C7E' }, borderRadius: 2 }}
              >
                Contactar soporte
              </Button>
            )}
          </Box>
        </CardContent>
      </Card>
    </Container>
  );
}
